import { Spinner } from 'ui/spinner';
import { InfoBanner } from 'ui/banner';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { spacing } from 'ui/theme';
import styled from 'styled-components';
import { displayDate, getNewDate, DATE_FORMAT_FULL_WITH_TIME } from 'utils/date';

import { ChangeLogEntry, FeatureFlag } from '../../types';

const DL = styled.dl`
  display: grid;
  grid-template-columns: 1fr 8fr;
  grid-template-rows: auto;
  row-gap: ${spacing.quarter};
`;

const StyledInfoBanner = styled(InfoBanner)`
  &:not(:first-of-type) {
    margin-top: ${spacing.base};
  }
`;

type ChangeLogModalProps = {
  changeLog: ChangeLogEntry[];
  featureFlag: FeatureFlag;
  isFetching: boolean;
  onClose: () => void;
};

export const ChangeLogModal = ({
  changeLog,
  featureFlag,
  isFetching,
  onClose,
}: ChangeLogModalProps) => {
  return (
    <Modal
      data-test="change-log-modal"
      id="change-log-modal"
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.LARGE}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>Change Log for {featureFlag.feature}</ModalHeader>
      <ModalBody>
        {isFetching ? (
          <Spinner data-test="spinner" />
        ) : (
          changeLog.map((changeLogEntry, index) => (
            <StyledInfoBanner key={`change-log-${index}`}>
              <DL>
                <dt>Version:</dt>
                <dd>{changeLogEntry.version}</dd>
                <dt>Date:</dt>
                <dd>
                  {displayDate(
                    getNewDate({ date: changeLogEntry.createdAt }),
                    DATE_FORMAT_FULL_WITH_TIME,
                  )}
                </dd>
                <dt>User:</dt>
                <dd>{changeLogEntry.authorEmail}</dd>
                <dt>Comment:</dt>
                <dd>{changeLogEntry.comment}</dd>
                <dt>Changes:</dt>
                <dd>{changeLogEntry.changes.join(', ')}</dd>
              </DL>
            </StyledInfoBanner>
          ))
        )}
      </ModalBody>
      <ModalFooter />
    </Modal>
  );
};
